/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Alipay_Private_KeyInputs */

const en_admin_settings_fields_alipay_private_key = /** @type {(inputs: Admin_Settings_Fields_Alipay_Private_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Private Key (RSA2)`)
};

/**
* | output |
* | --- |
* | "Private Key (RSA2)" |
*
* @param {Admin_Settings_Fields_Alipay_Private_KeyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_alipay_private_key = /** @type {((inputs?: Admin_Settings_Fields_Alipay_Private_KeyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Alipay_Private_KeyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_alipay_private_key(inputs)
});
export { admin_settings_fields_alipay_private_key as "admin.settings.fields.alipay_private_key" }